import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure3 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        backgroundColor:'rgba(255, 255, 255, 0.0)',
        marginTop: 50,
        height: 600,
        style: {
            fontFamily: 'Montserrat'
        }
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },
    colors: ['#4c5d6a', '#ed7d31'],
    exporting: {
        enabled: false
    },
    xAxis: [{
        categories: ['2005','2006','2007','2008','2009','2010','2011','2012','2013','2014','2015','2016','2017','2018','2019','2020', '2021*'],
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#d7d7d7'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],
    yAxis: [{ // Primary yAxis
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        // lineColor: "#5b9bd5",
        // tickColor: "#5b9bd5",
        offset: 10,
        gridLineWidth: 0,
        max: 18,
        min: 0,
        tickInterval: 2,
        startOnTick: false,
        endOnTick: false,
        title: {
            text: 'Pourcentage',
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }, { // Secondary yAxis
        title: {
            text: null,
            style: {
                color: Highcharts.getOptions().colors[0]
            }
        },
        max: 900,
        min: 0,
        tickInterval: 100,
        startOnTick: false,
        endOnTick: false,
        // plotLines: [{
        //     color: '#d7d7d7',
        //     width: 1,
        //     value: 1000
        // }],
        offset: 10,
        gridLineWidth: 0,
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
        //title: {
        //    text: 'Millionss',
        //    style: {
        //        color: Highcharts.getOptions().colors[1]
        //    }
        //},
        opposite: true
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        // formatter: function() {
        //     console.log(this)
        // },
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                //enabled: false,
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [{
        name: 'Nombre de personnes sous-alimentées (Millionss, axe de droite)',
        id: "number",
        type: 'line',
        yAxis: 1,
        color: '#0d6bb6',
        
        zoneAxis: 'x',
        zones: [{
            value: 15
        }, {
            dashStyle: 'dot'
        }],

        dataLabels: {
            enabled: false,
            formatter: function () {
                return this.y.toFixed(1);
            },
            style: {
                fontWeight: 'normal',
                color: '#999999',
                textOutline: false,
                fontSize: '12px'
            }

        },

        data: [
          { y: 805.5,
	       dataLabels: {enabled:true,
		       format: '{point.y:,.1f}'} },
          758.7,
          703.7,
          676.3,
          674.5,
          { y: 601.3, 
		       dataLabels: {enabled:true,
		       format: '{point.y:,.1f}'} },
          586.2,
          584.7,
          570.7,
	       { y: 571.6, dataLabels: {enabled:true,
		       format: '{point.y:,.1f}'} },
	       { y: 588.6, dataLabels: {enabled:true,
		       format: '{point.y:,.1f}'} },
          585.1,
          573.3,
          590.6,
	       { y: 618.4,dataLabels: {enabled:true,
		       format: '{point.y:,.1f}'} },
          721.7, 
          {
            y: 767.9,
	       dataLabels: {enabled:true,
	       format: '{point.y:,.1f}'},
            marker: {
                fillColor: '#ffffff',
                lineColor:'#0d6bb6',
                
                lineWidth: 2
            },
          }
        ],
        tooltip: {
            valueSuffix: ' Millions'
        }
        

    }, {
        name: 'Number of people undernourished upper bound',
        type: 'arearange',
        color: '#0d6bb6',
        lineWidth: 0,
        linkedTo: ':previous',
        fillOpacity: 0.3,
        zIndex: 0,
        yAxis: 1,
        
        zoneAxis: 'x',
        marker: {
            enabled: false
        },
        data: [
            {
                x: 14,
                low: 618.4,
                high: 618.4,
                name: "Point1",
            },
            {
                x: 15,
                low: 675.5,
                high: 765.2,
                name: "Point2",
                dataLabels: {
			   enabled:true,
			   format: '{point.y:,.1f}',
                    allowOverlap:true, 
                    className:'arearange-value',
                    padding:5,
                    // eslint-disable-next-line
                    enabled: true,
                    formatter: function () {
                        return this.y;
                    },
                    style: {
                        fontWeight: 'normal',
                        textOutline: false,
                        color: '#999999',
                        fontSize: '12px'
                    }

                }
            },
            {
                x: 16,
                low: 701.9,
                high: 828.0,
                name: "Point1",
            },
        ],
        tooltip: {
	valueSuffix: 'Millions'
        },
        
    }, {
        name: 'Prévalence de la sous-alimentation (%, axe de gauche)',
        id: "prev",
        type: 'line',
        color: '#ed7d31',
        
        zoneAxis: 'x',
        zones: [{
            value: 15
        }, {
            dashStyle: 'dot'
        }],
        dataLabels: {
            enabled: false,
            formatter: function () {
                return this.y.toFixed(1)+"%";
            },
            style: {
                fontWeight: 'normal',
                textOutline: false,
                color: '#999999',
                fontSize: '12px'
            }
        },
        data: [
	       { y: 12.3, dataLabels: {enabled:true,
		       format: '{point.y:,.1f}'} },
          11.5, 
          10.5, 
          10.0, 
          9.8,
	       { y:8.6, dataLabels: {enabled:true,
		       format: '{point.y:,.1f}'} },
          8.3,
          8.2,
          7.9,
	       { y: 7.8, dataLabels: {enabled:true,
		       format: '{point.y:,.1f}'} },
	       { y: 8.0, dataLabels: {enabled:true,
		       format: '{point.y:,.1f}'} },
          7.8,
          7.6,
          7.7,
	       { y:8.0, dataLabels: {enabled:true,
		       format: '{point.y:,.1f}'} },
	       { y: 9.3, dataLabels: {enabled:true,
		       format: '{point.y:,.1f}'} },
            {
              y: 9.8,
              dataLabels: {
			 enabled:true,
			 format: '{point.y:,.1f}'
                //   x: 200, 
                //   y: -10
                },
              marker: {
                  fillColor: '#ffffff',
                  lineColor:'#ed7d31',
                  lineWidth: 2
                 
              },

          }
        ],
        tooltip: {
            valueSuffix: '%'
        }
    }, {
        name: 'Prevalence of undernourishment range',
        type: 'arearange',
        color: '#ed7d31',
        lineWidth: 0,
        linkedTo: ':previous',
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
            enabled: false
        },
        data: [
            {
                x: 14,
                low: 8.0,
                high: 8.0,
                name: "Point1",
            },
            {
                x: 15,
                low: 8.7,
                high: 9.8,
                name: "Point2",
                dataLabels: {
			   enabled:true,
			   format: '{point.y:,.1f}',
                    allowOverlap:true, 
                    className:'arearange-value',
                    padding:5,
                    // verticalAlign:top
                    // useHTML:true
                    formatter: function () {
                        return this.y+"%";
                    },
                    style: {
                        fontWeight: 'normal',
                        textOutline: false,
                        color: '#999999',
                        fontSize: '12px'
                    }

                }
            },
            {
                x: 16,
                low: 8.9,
                high: 10.5,
                name: "Point1",
            },
        ],
        tooltip: {
            valueSuffix: '%'
        },
        
    }],


}